import { useMutation, useQueryClient } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IApplianceModel } from '../../types/Appliance/ApplianceModel';
import { useDefaultMutateResponseHandlers } from '../../hooks/useDefaultMutateResponeHandlers';

export default function useApplianceModelsMutations() {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();
  const { handleSuccess, handleError } =
    useDefaultMutateResponseHandlers('Appliance Model');

  const createApplianceModel = useMutation({
    mutationFn: (applianceModel: IApplianceModel) =>
      post('/v1/superadmin/hardware/models', applianceModel),
    onError: (error) => handleError(error, 'create'),
    onSuccess: (data) => handleSuccess(data, 'create'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.models());
      queryClient.invalidateQueries(applianceQueryKeys.superAdminModels());
    },
  });

  const updateApplianceModel = useMutation({
    mutationFn: (applianceModel: IApplianceModel) =>
      put(
        `/v1/superadmin/hardware/models/${applianceModel.id}`,
        applianceModel
      ),
    onError: (error) => handleError(error, 'update'),
    onSuccess: (data) => handleSuccess(data, 'update'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.models());
      queryClient.invalidateQueries(applianceQueryKeys.superAdminModels());
    },
  });

  const delApplianceModel = useMutation({
    mutationFn: (applianceModel: IApplianceModel) =>
      del(`/v1/superadmin/hardware/models/${applianceModel.id}`),
    onError: (error) => handleError(error, 'delete'),
    onSuccess: (data) => handleSuccess(data, 'delete'),
    onSettled: () => {
      queryClient.invalidateQueries(applianceQueryKeys.models());
      queryClient.invalidateQueries(applianceQueryKeys.superAdminModels());
    },
  });

  return {
    createApplianceModel,
    updateApplianceModel,
    delApplianceModel,
  };
}
